import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.primary[700]};
    width: ${theme.componentStyles.navBarWidth};
    text-align: center;
  `}
`;
